const TinyChevronUp = () => (
  <>
    <path
      fill="currentColor"
      d="M15.245 13.373a.4.4 0 0 1-.111.289.38.38 0 0 1-.293.12H9.164a.37.37 0 0 1-.293-.123.42.42 0 0 1-.111-.289q0-.04.13-.284l2.678-2.676a.7.7 0 0 1 .199-.143.55.55 0 0 1 .235-.05q.128 0 .236.05.105.05.199.143l2.677 2.677q.056.055.093.129a.34.34 0 0 1 .037.157"
    />
  </>
)
export default TinyChevronUp
